import React, { FC } from 'react';

import { Box, Button, ButtonProps, Center } from '@chakra-ui/react';

import { CustomTooltip } from 'components/DataDisplay';

import { colorOpacity, customTheme } from '../../../../../theme';

export interface ButtonGroupItem {
  label?: string | React.ReactNode;
  icon?: React.ReactNode;
  tooltip?: string;
  value: any;
  isDisabled?: boolean;
}

interface ButtonGroupStyles {
  button?: ButtonProps;
}

export interface IButtonGroup {
  items: ButtonGroupItem[];
  value?: ButtonGroupItem;
  styles?: ButtonGroupStyles;
  onClick?(value: ButtonGroupItem);
}

export const ButtonGroup: FC<IButtonGroup> = props => {
  const { items, value, styles, onClick } = props;

  const handleClick = item => {
    onClick?.(item);
  };

  const renderLabel = item =>
    item?.icon ? (
      <Box boxSize={5}>
        <Center w="full" h="full" color="primary">
          {item?.icon}
        </Center>
      </Box>
    ) : (
      item?.label
    );

  return (
    <Box>
      {items.map((item, index) => (
        <Button
          key={item.value ?? item.label ?? index}
          py={4}
          size="sm"
          border="1px solid"
          borderColor={customTheme.colors.gray['100']}
          borderRight={
            index === 0 && value?.value !== item.value ? 'none' : '1px'
          }
          borderLeft={
            index === items?.length - 1 && value?.value !== item.value
              ? 'none'
              : '1px'
          }
          borderLeftColor={customTheme.colors.gray['100']}
          borderRightColor={customTheme.colors.gray['100']}
          bg="transparent"
          color={customTheme.colors.gray['300']}
          borderLeftRadius={index === 0 ? 6 : 0}
          borderRightRadius={index === items?.length - 1 ? 6 : 0}
          onClick={() => handleClick(item)}
          isActive={item.value === value?.value}
          aria-pressed={item.value === value?.value}
          fontWeight={400}
          _hover={{
            bg: colorOpacity(customTheme.colors.primary, 0.2),
            borderColor: colorOpacity(customTheme.colors.primary, 0.4),
            color: 'primary',
          }}
          _active={{
            bg: colorOpacity(customTheme.colors.primary, 0.2),
            borderColor: colorOpacity(customTheme.colors.primary, 0.4),
            color: 'primary',
          }}
          _focus={{
            outline: 'none',
            color: 'primary',
          }}
          fontSize="16px"
          isDisabled={item.isDisabled}
          {...styles?.button}
        >
          {item?.tooltip ? (
            <CustomTooltip label={item?.tooltip}>
              {renderLabel(item)}
            </CustomTooltip>
          ) : (
            renderLabel(item)
          )}
        </Button>
      ))}
    </Box>
  );
};
